import * as React from 'react';
import SelectField from '../../common/form-controls/SelectField';
import { PortOpeningRequestsDirection } from '../../../models/enums/POR/PortOpeningRequestsDirection';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import { OnPremPortOpeningRequestsTypes } from '../../../models/enums/POR/OnPremPortOpeningRequestsTypes';

interface OnPremPORScopeInputProps{
	direction: FieldHandler<string>
	type: string;
}

interface OnPremPORScopeInputState { }

export class OnPremPORScopeInput extends React.Component<OnPremPORScopeInputProps, OnPremPORScopeInputState> {

	scopeOptions = () => {
		if (this.props.type == '') return []
		if (this.props.type == OnPremPortOpeningRequestsTypes.InternetDMZ.name) {
			return [
				{ value: PortOpeningRequestsDirection.L4ToInternet.name, text: PortOpeningRequestsDirection.L4ToInternet.displayName },
				{ value: PortOpeningRequestsDirection.iBossProxyToInternet.name, text: PortOpeningRequestsDirection.iBossProxyToInternet.displayName },
				{ value: PortOpeningRequestsDirection.InternetToNorthFirewall.name, text: PortOpeningRequestsDirection.InternetToNorthFirewall.displayName },
				{ value: PortOpeningRequestsDirection.InternetToSouthFirewall.name, text: PortOpeningRequestsDirection.InternetToSouthFirewall.displayName },
			];
		} else {
			return [
				{ value: PortOpeningRequestsDirection.L4ToL3LablanXTO.name, text: PortOpeningRequestsDirection.L4ToL3LablanXTO.displayName },
			];
		}
	};
	
	render() {
		return (
			<SelectField
				label="Scope"
				className="full-width"
				options={this.scopeOptions()}
				{...this.props.direction}
			/>
		);
	}
}
